export const isDev = (process.env.NODE_ENV === "development")

export const isEmpty = (value) => {
    if (value === undefined || value === null) return true;
    if (typeof value === 'string') return value.trim() === '';
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === 'object') return Object.keys(value).length === 0;
    if (typeof value === 'number') return value === 0;
    if (typeof value === 'boolean') return !value;
    if (typeof value === 'function') return false;
    return false;
}

export const saveFilter = (filterName, filter) => {
    localStorage.setItem(`filter_${filterName}`, JSON.stringify(filter));
}

export const loadFilter = (filterName, defaultFilter) => {
    const filter = localStorage.getItem(`filter_${filterName}`);
    if (filter) return JSON.parse(filter);
    else return defaultFilter;
}

export const showConsoleBanner = (version) => {
    if (typeof window !== 'undefined') {
        if (window.__SPARKLING_EMAIL_BANNER_SHOWN__) return;
        window.__SPARKLING_EMAIL_BANNER_SHOWN__ = true;
    }

    const ascii = `
    ███████╗██████╗  █████╗ ██████╗ ██╗  ██╗██╗     ██╗███╗   ██╗ ██████╗     ███████╗███╗   ███╗ █████╗ ██╗██╗
    ██╔════╝██╔══██╗██╔══██╗██╔══██╗██║ ██╔╝██║     ██║████╗  ██║██╔════╝     ██╔════╝████╗ ████║██╔══██╗██║██║
    ███████╗██████╔╝███████║██████╔╝█████╔╝ ██║     ██║██╔██╗ ██║██║  ███╗    █████╗  ██╔████╔██║███████║██║██║
    ╚════██║██╔═══╝ ██╔══██║██╔══██╗██╔═██╗ ██║     ██║██║╚██╗██║██║   ██║    ██╔══╝  ██║╚██╔╝██║██╔══██║██║██║
    ███████║██║     ██║  ██║██║  ██║██║  ██╗███████╗██║██║ ╚████║╚██████╔╝    ███████╗██║ ╚═╝ ██║██║  ██║██║███████╗
    ╚══════╝╚═╝     ╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝╚═╝╚═╝  ╚═══╝ ╚═════╝     ╚══════╝╚═╝     ╚═╝╚═╝  ╚═╝╚═╝╚══════╝
    ✨ Sparkling Email
    ✨ Version: v${version}
  `;

    console.log(`%c${ascii}`, 'color:#00d8ff; font-weight:bold; font-family:monospace;');
};
